import CreateProcessRequests from './views/Create.vue'
import ListProcessRequests from './views/List.vue'

export const PendingProcessesRoutes = [
  {
    path: '/pending-processes',
    name: 'ListProcessRequests',
    component: ListProcessRequests,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'pending_process:list'
    }
  },
  {
    path: '/pending-process',
    name: 'CreateProcessRequests',
    component: CreateProcessRequests,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'calc_controller:execute'
    }
  }
]
